import React from 'react';
import { 
  Wifi, 
  Tv, 
  Bed, 
  UtensilsCrossed, 
  Bath,
  Trees,
  Car,
  Wind,
  Flame
} from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import BookingWidget from '../components/BookingWidget';

const Amenities = () => {
  const { t } = useLanguage();

  const amenityCategories = [
    {
      title: t('amenities.internetTitle'),
      icon: Wifi,
      items: [
        t('amenities.wifi'),
        t('amenities.netflix'),
        t('amenities.smartTv'),
        t('amenities.tvBedroom'),
        t('amenities.workDesk'),
      ],
    },
    {
      title: t('amenities.accommodationTitle'),
      icon: Bed,
      items: [
        t('amenities.fourBedrooms'),
        t('amenities.eightGuests'),
        t('amenities.linens'),
        t('amenities.towels'),
        t('amenities.travelCots'),
      ],
    },
    {
      title: t('amenities.kitchenTitle'),
      icon: UtensilsCrossed,
      items: [
        t('amenities.fullyEquipped'),
        t('amenities.fridge'),
        t('amenities.oven'),
        t('amenities.stove'),
        t('amenities.coffeeMaker'),
        t('amenities.kettle'),
        t('amenities.cookware'),
      ],
    },
    {
      title: t('amenities.bathroomTitle'),
      icon: Bath,
      items: [
        t('amenities.privateBathrooms'),
        t('amenities.hairDryer'),
        t('amenities.toiletries'),
      ],
    },
    {
      title: t('amenities.outdoorTitle'),
      icon: Trees,
      items: [
        t('amenities.privateGarden'),
        t('amenities.terrace'),
        t('amenities.outdoorSeating'),
        t('amenities.bbq'),
      ],
    },
    {
      title: t('amenities.practicalTitle'),
      icon: Car,
      items: [
        t('amenities.parking'),
        t('amenities.safe'),
        t('amenities.washingMachine'),
        t('amenities.dryer'),
        t('amenities.airConditioning'),
        t('amenities.gym'),
        t('amenities.keyBox'),
        t('amenities.pet'),
      ],
    },
  ];

  return (
    <div data-testid="amenities-page" className="min-h-screen pt-24 pb-32 bg-white">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">
          Villa Aristotle
        </p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1E3A5F] mb-6">
          {t('amenities.title')}
        </h1>
      </div>

      {/* Amenities Grid */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {amenityCategories.map((category, index) => {
            const Icon = category.icon;
            return (
              <div 
                key={index}
                className="bg-[#f8fafc] border border-[#1E3A5F]/10 rounded-sm p-6"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-[#1E3A5F]/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#D4A72C]" />
                  </div>
                  <h3 className="font-serif text-lg text-[#1E3A5F]">{category.title}</h3>
                </div>
                <ul className="space-y-2">
                  {category.items.map((item, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-[#1E3A5F]/70">
                      <div className="w-1.5 h-1.5 bg-[#D4A72C] rounded-full" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>

      {/* Sticky Mobile Booking */}
      <BookingWidget variant="sticky" />
    </div>
  );
};

export default Amenities;
